/* tslint:disable */
/* eslint-disable */
/**
 * openapi
 * bales cloud
 *
 * The version of the OpenAPI document: 1.0
 * Contact: test@example.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import globalAxios, { AxiosPromise, AxiosInstance, AxiosRequestConfig } from 'axios';
import { Configuration } from '../configuration';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from '../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, RequestArgs, BaseAPI, RequiredError } from '../base';
// @ts-ignore
import { GetTriggerTargetActionApprovals200Response } from '../models';
// @ts-ignore
import { PutApproveTriggerTargetActionRequest } from '../models';
/**
 * TriggerTargetActionApi - axios parameter creator
 * @export
 */
export const TriggerTargetActionApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * トリガーアクション承認者取得API
         * @summary トリガーアクション承認者取得API
         * @param {number} [page] infinityLoading用ページ番号
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTriggerTargetActionApprovals: async (page?: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/user/trigger_target_actions/approvals`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * トリガーアクション承認API
         * @summary トリガーアクション承認API
         * @param {number} triggerTargetActionId トリガ対象レコードーID
         * @param {PutApproveTriggerTargetActionRequest} [putApproveTriggerTargetActionRequest] トリガーアクション承認APIResponse
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        putApproveTriggerTargetAction: async (triggerTargetActionId: number, putApproveTriggerTargetActionRequest?: PutApproveTriggerTargetActionRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'triggerTargetActionId' is not null or undefined
            assertParamExists('putApproveTriggerTargetAction', 'triggerTargetActionId', triggerTargetActionId)
            const localVarPath = `/api/user/trigger_target_actions/{triggerTargetActionId}/approve`
                .replace(`{${"triggerTargetActionId"}}`, encodeURIComponent(String(triggerTargetActionId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(putApproveTriggerTargetActionRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * トリガーアクション承認API
         * @summary トリガーアクション承認API
         * @param {number} triggerTargetActionId トリガ対象レコードーID
         * @param {PutApproveTriggerTargetActionRequest} [putApproveTriggerTargetActionRequest] トリガーアクション承認APIResponse
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        putRejectTriggerTargetAction: async (triggerTargetActionId: number, putApproveTriggerTargetActionRequest?: PutApproveTriggerTargetActionRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'triggerTargetActionId' is not null or undefined
            assertParamExists('putRejectTriggerTargetAction', 'triggerTargetActionId', triggerTargetActionId)
            const localVarPath = `/api/user/trigger_target_actions/{triggerTargetActionId}/reject`
                .replace(`{${"triggerTargetActionId"}}`, encodeURIComponent(String(triggerTargetActionId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(putApproveTriggerTargetActionRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * TriggerTargetActionApi - functional programming interface
 * @export
 */
export const TriggerTargetActionApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = TriggerTargetActionApiAxiosParamCreator(configuration)
    return {
        /**
         * トリガーアクション承認者取得API
         * @summary トリガーアクション承認者取得API
         * @param {number} [page] infinityLoading用ページ番号
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getTriggerTargetActionApprovals(page?: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetTriggerTargetActionApprovals200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getTriggerTargetActionApprovals(page, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * トリガーアクション承認API
         * @summary トリガーアクション承認API
         * @param {number} triggerTargetActionId トリガ対象レコードーID
         * @param {PutApproveTriggerTargetActionRequest} [putApproveTriggerTargetActionRequest] トリガーアクション承認APIResponse
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async putApproveTriggerTargetAction(triggerTargetActionId: number, putApproveTriggerTargetActionRequest?: PutApproveTriggerTargetActionRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.putApproveTriggerTargetAction(triggerTargetActionId, putApproveTriggerTargetActionRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * トリガーアクション承認API
         * @summary トリガーアクション承認API
         * @param {number} triggerTargetActionId トリガ対象レコードーID
         * @param {PutApproveTriggerTargetActionRequest} [putApproveTriggerTargetActionRequest] トリガーアクション承認APIResponse
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async putRejectTriggerTargetAction(triggerTargetActionId: number, putApproveTriggerTargetActionRequest?: PutApproveTriggerTargetActionRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.putRejectTriggerTargetAction(triggerTargetActionId, putApproveTriggerTargetActionRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * TriggerTargetActionApi - factory interface
 * @export
 */
export const TriggerTargetActionApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = TriggerTargetActionApiFp(configuration)
    return {
        /**
         * トリガーアクション承認者取得API
         * @summary トリガーアクション承認者取得API
         * @param {number} [page] infinityLoading用ページ番号
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTriggerTargetActionApprovals(page?: number, options?: any): AxiosPromise<GetTriggerTargetActionApprovals200Response> {
            return localVarFp.getTriggerTargetActionApprovals(page, options).then((request) => request(axios, basePath));
        },
        /**
         * トリガーアクション承認API
         * @summary トリガーアクション承認API
         * @param {number} triggerTargetActionId トリガ対象レコードーID
         * @param {PutApproveTriggerTargetActionRequest} [putApproveTriggerTargetActionRequest] トリガーアクション承認APIResponse
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        putApproveTriggerTargetAction(triggerTargetActionId: number, putApproveTriggerTargetActionRequest?: PutApproveTriggerTargetActionRequest, options?: any): AxiosPromise<void> {
            return localVarFp.putApproveTriggerTargetAction(triggerTargetActionId, putApproveTriggerTargetActionRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * トリガーアクション承認API
         * @summary トリガーアクション承認API
         * @param {number} triggerTargetActionId トリガ対象レコードーID
         * @param {PutApproveTriggerTargetActionRequest} [putApproveTriggerTargetActionRequest] トリガーアクション承認APIResponse
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        putRejectTriggerTargetAction(triggerTargetActionId: number, putApproveTriggerTargetActionRequest?: PutApproveTriggerTargetActionRequest, options?: any): AxiosPromise<void> {
            return localVarFp.putRejectTriggerTargetAction(triggerTargetActionId, putApproveTriggerTargetActionRequest, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * TriggerTargetActionApi - interface
 * @export
 * @interface TriggerTargetActionApi
 */
export interface TriggerTargetActionApiInterface {
    /**
     * トリガーアクション承認者取得API
     * @summary トリガーアクション承認者取得API
     * @param {number} [page] infinityLoading用ページ番号
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TriggerTargetActionApiInterface
     */
    getTriggerTargetActionApprovals(page?: number, options?: AxiosRequestConfig): AxiosPromise<GetTriggerTargetActionApprovals200Response>;

    /**
     * トリガーアクション承認API
     * @summary トリガーアクション承認API
     * @param {number} triggerTargetActionId トリガ対象レコードーID
     * @param {PutApproveTriggerTargetActionRequest} [putApproveTriggerTargetActionRequest] トリガーアクション承認APIResponse
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TriggerTargetActionApiInterface
     */
    putApproveTriggerTargetAction(triggerTargetActionId: number, putApproveTriggerTargetActionRequest?: PutApproveTriggerTargetActionRequest, options?: AxiosRequestConfig): AxiosPromise<void>;

    /**
     * トリガーアクション承認API
     * @summary トリガーアクション承認API
     * @param {number} triggerTargetActionId トリガ対象レコードーID
     * @param {PutApproveTriggerTargetActionRequest} [putApproveTriggerTargetActionRequest] トリガーアクション承認APIResponse
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TriggerTargetActionApiInterface
     */
    putRejectTriggerTargetAction(triggerTargetActionId: number, putApproveTriggerTargetActionRequest?: PutApproveTriggerTargetActionRequest, options?: AxiosRequestConfig): AxiosPromise<void>;

}

/**
 * Request parameters for getTriggerTargetActionApprovals operation in TriggerTargetActionApi.
 * @export
 * @interface TriggerTargetActionApiGetTriggerTargetActionApprovalsRequest
 */
export interface TriggerTargetActionApiGetTriggerTargetActionApprovalsRequest {
    /**
     * infinityLoading用ページ番号
     * @type {number}
     * @memberof TriggerTargetActionApiGetTriggerTargetActionApprovals
     */
    readonly page?: number
}

/**
 * Request parameters for putApproveTriggerTargetAction operation in TriggerTargetActionApi.
 * @export
 * @interface TriggerTargetActionApiPutApproveTriggerTargetActionRequest
 */
export interface TriggerTargetActionApiPutApproveTriggerTargetActionRequest {
    /**
     * トリガ対象レコードーID
     * @type {number}
     * @memberof TriggerTargetActionApiPutApproveTriggerTargetAction
     */
    readonly triggerTargetActionId: number

    /**
     * トリガーアクション承認APIResponse
     * @type {PutApproveTriggerTargetActionRequest}
     * @memberof TriggerTargetActionApiPutApproveTriggerTargetAction
     */
    readonly putApproveTriggerTargetActionRequest?: PutApproveTriggerTargetActionRequest
}

/**
 * Request parameters for putRejectTriggerTargetAction operation in TriggerTargetActionApi.
 * @export
 * @interface TriggerTargetActionApiPutRejectTriggerTargetActionRequest
 */
export interface TriggerTargetActionApiPutRejectTriggerTargetActionRequest {
    /**
     * トリガ対象レコードーID
     * @type {number}
     * @memberof TriggerTargetActionApiPutRejectTriggerTargetAction
     */
    readonly triggerTargetActionId: number

    /**
     * トリガーアクション承認APIResponse
     * @type {PutApproveTriggerTargetActionRequest}
     * @memberof TriggerTargetActionApiPutRejectTriggerTargetAction
     */
    readonly putApproveTriggerTargetActionRequest?: PutApproveTriggerTargetActionRequest
}

/**
 * TriggerTargetActionApi - object-oriented interface
 * @export
 * @class TriggerTargetActionApi
 * @extends {BaseAPI}
 */
export class TriggerTargetActionApi extends BaseAPI implements TriggerTargetActionApiInterface {
    /**
     * トリガーアクション承認者取得API
     * @summary トリガーアクション承認者取得API
     * @param {TriggerTargetActionApiGetTriggerTargetActionApprovalsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TriggerTargetActionApi
     */
    public getTriggerTargetActionApprovals(requestParameters: TriggerTargetActionApiGetTriggerTargetActionApprovalsRequest = {}, options?: AxiosRequestConfig) {
        return TriggerTargetActionApiFp(this.configuration).getTriggerTargetActionApprovals(requestParameters.page, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * トリガーアクション承認API
     * @summary トリガーアクション承認API
     * @param {TriggerTargetActionApiPutApproveTriggerTargetActionRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TriggerTargetActionApi
     */
    public putApproveTriggerTargetAction(requestParameters: TriggerTargetActionApiPutApproveTriggerTargetActionRequest, options?: AxiosRequestConfig) {
        return TriggerTargetActionApiFp(this.configuration).putApproveTriggerTargetAction(requestParameters.triggerTargetActionId, requestParameters.putApproveTriggerTargetActionRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * トリガーアクション承認API
     * @summary トリガーアクション承認API
     * @param {TriggerTargetActionApiPutRejectTriggerTargetActionRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TriggerTargetActionApi
     */
    public putRejectTriggerTargetAction(requestParameters: TriggerTargetActionApiPutRejectTriggerTargetActionRequest, options?: AxiosRequestConfig) {
        return TriggerTargetActionApiFp(this.configuration).putRejectTriggerTargetAction(requestParameters.triggerTargetActionId, requestParameters.putApproveTriggerTargetActionRequest, options).then((request) => request(this.axios, this.basePath));
    }
}
